import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import scrollIntoView from 'scroll-into-view-if-needed';
import { StaticMenuService } from 'NewAngular/services/static-menus/static-menus.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/static-menus/static-menus.service";
import * as i2 from "../../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = a0 => ({ selected: a0 });
function InfoFieldListComponent_ycn_loading_symbol_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 4);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function InfoFieldListComponent_ng_template_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵlistener("click", function InfoFieldListComponent_ng_template_3_div_5_Template_div_click_1_listener() { const category_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.selectCategoryByName(category_r3.name)); });
    i0.ɵɵelement(2, "span", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, category_r3.name === ctx_r3.selectedCategoryName));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", category_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", category_r3.name);
} }
function InfoFieldListComponent_ng_template_3_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function InfoFieldListComponent_ng_template_3_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵlistener("click", function InfoFieldListComponent_ng_template_3_div_10_Template_div_click_1_listener() { const infoField_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.selectHandler.emit(infoField_r6)); });
    i0.ɵɵelement(2, "span", 14);
    i0.ɵɵtemplate(3, InfoFieldListComponent_ng_template_3_div_10_div_3_Template, 3, 1, "div", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const infoField_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", infoField_r6.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.selectedInfoFieldsMap[infoField_r6.key]);
} }
function InfoFieldListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7);
    i0.ɵɵtext(3, "Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtemplate(5, InfoFieldListComponent_ng_template_3_div_5_Template, 3, 5, "div", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
    i0.ɵɵtext(8, "Item");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵtemplate(10, InfoFieldListComponent_ng_template_3_div_10_Template, 4, 2, "div", 11);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r3.categories);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r3.categoryInfoFieldsMap[ctx_r3.selectedCategoryName]);
} }
/**
 * Info Field List Component
 *
 * Handles displaying the static menu of info fields and allows selection of one or multiple
 * info fields depending on the isSingleSelect input.
 *
 * Input Properties:
 *  infoType: 'company', 'fund', 'all', etc.
 *  modalOpen: Whether the parent modal is open. This component will only autoscroll to
 *             the selected info field if the modal is open.
 *  selectedInfoFields: array of selected info fields. Will only ever hold 1 element if isSingleSelect.
 *  isSingleSelect: Whether one or multiple info fields should be able to be selected at a time.
 *  defaultOnly: info needed for context aware data source filtering
 *
 * Output Properties:
 *  selectHandler: emits any info field that is clicked.
 */
export class InfoFieldListComponent {
    constructor(el, staticMenuService) {
        this.el = el;
        this.staticMenuService = staticMenuService;
        this.selectedInfoFields = [];
        this.isSingleSelect = true;
        this.defaultOnly = false;
        this.selectHandler = new EventEmitter();
        // Categories can be passed in or fetched here
        this.categories = [];
        this.fetchCategories = true;
        // This is used to display the info fields for the selected category.
        this.categoryInfoFieldsMap = { '': [] };
        this.selectedCategoryName = '';
        // Used to show checkmarks for selected fields
        this.selectedInfoFieldsMap = {};
        this.MENU_TYPE = 'infoFieldMenu';
        this.loading = false;
    }
    ngOnInit() {
        if (this.fetchCategories) {
            this.loading = true;
            this.staticMenuService
                .getStaticMenu(this.MENU_TYPE, this.infoType, this.defaultOnly)
                .pipe(finalize(() => {
                this.loading = false;
            }))
                .subscribe((response) => {
                this.categories = response;
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.selectedInfoFields && !changes.selectedInfoFields.isFirstChange()) {
            // Mark all fields in the selectedInfoFields array as selected
            this.selectedInfoFieldsMap = this.selectedInfoFields.reduce((acc, infoField) => ({
                ...acc,
                [infoField.key]: true,
            }), {});
        }
        if (changes.modalOpen && !changes.modalOpen.isFirstChange()) {
            if (this.modalOpen) {
                // When the modal opens, scroll to the selected field if it is single select
                if (this.isSingleSelect && this.selectedInfoFields && this.selectedInfoFields.length) {
                    this.autoSelectInfoField({ search_id: this.selectedInfoFields[0].key }, false);
                }
                else {
                    // Select the first category by default otherwise
                    this.selectCategoryByName(this.categories[0].name);
                }
            }
            else {
                // Clear the selected category when the modal is closed
                this.selectedCategoryName = '';
            }
        }
        if (changes.categories) {
            this.categoryInfoFieldsMap = {};
        }
    }
    autoSelectInfoField(result, emitField = true) {
        let menuInfoField = null;
        let menuCategory = null;
        // Find the info field and category in the static menu that match
        // the object selected in the autocomplete
        this.categories.some((category) => {
            const infoField = category.list_items.find((field) => field.key === result.search_id);
            if (infoField) {
                menuCategory = category;
                menuInfoField = infoField;
            }
            return !!infoField;
        });
        if (!menuInfoField) {
            return;
        }
        this.selectCategoryByName(menuCategory.name);
        if (emitField) {
            this.selectHandler.emit(menuInfoField);
        }
        this.scrollTo(`[id='${menuInfoField.key}']`);
    }
    selectCategoryByName(categoryName) {
        this.selectedCategoryName = categoryName;
        this.scrollTo(`div.linked-list-item-header[id="${this.selectedCategoryName}"]`);
        // If this category was selected before then we don't need
        // to update the map again with the array of info fields in the category
        if (this.categoryInfoFieldsMap[categoryName]) {
            return;
        }
        const selectedCategory = this.categories.find((category) => category.name === categoryName);
        // Update the map so that we display the info fields in the selected category
        if (selectedCategory) {
            this.categoryInfoFieldsMap[categoryName] = selectedCategory.list_items;
        }
    }
    scrollTo(querySelector) {
        setTimeout(() => {
            const selectedEl = this.el.nativeElement.querySelector(querySelector);
            if (selectedEl) {
                scrollIntoView(selectedEl, {
                    block: 'center',
                    // do not scroll beyond the modal
                    boundary: (parent) => !parent.classList.contains('modal'),
                    scrollMode: 'if-needed',
                });
            }
        });
    }
}
InfoFieldListComponent.ɵfac = function InfoFieldListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InfoFieldListComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.StaticMenuService)); };
InfoFieldListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InfoFieldListComponent, selectors: [["ycn-info-field-list"]], inputs: { infoType: "infoType", modalOpen: "modalOpen", selectedInfoFields: "selectedInfoFields", isSingleSelect: "isSingleSelect", defaultOnly: "defaultOnly", categories: "categories", fetchCategories: "fetchCategories" }, outputs: { selectHandler: "selectHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 6, consts: [["showMenu", ""], [1, "modal-section", "form-row", "user-select-none"], [3, "submitHandler", "placeholder", "searchType", "buttonType", "defaultOnly"], [3, "loaderMessage", 4, "ngIf", "ngIfElse"], [3, "loaderMessage"], [1, "modal-section", "linked-lists", "user-select-none"], [1, "linked-list"], [1, "linked-list-header"], [1, "linked-list-body"], ["class", "linked-list-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "linked-list-body", "linked-list-sublist"], ["class", "linked-list-item", 4, "ngFor", "ngForOf"], [1, "linked-list-item", 3, "ngClass"], [1, "linked-list-item-header", 3, "click", "id"], [3, "textContent"], [1, "linked-list-item"], [1, "linked-list-item-header", 3, "click"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["ycnIcon", "", 3, "name"]], template: function InfoFieldListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "ycn-base-autocomplete", 2);
        i0.ɵɵlistener("submitHandler", function InfoFieldListComponent_Template_ycn_base_autocomplete_submitHandler_1_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.autoSelectInfoField($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(2, InfoFieldListComponent_ycn_loading_symbol_2_Template, 1, 1, "ycn-loading-symbol", 3)(3, InfoFieldListComponent_ng_template_3_Template, 11, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const showMenu_r7 = i0.ɵɵreference(4);
        i0.ɵɵadvance();
        i0.ɵɵproperty("placeholder", "Search for Info")("searchType", ctx.infoType + "_info_field")("buttonType", "icon-search")("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading)("ngIfElse", showMenu_r7);
    } }, dependencies: [i2.BaseAutocompleteComponent, i3.NgClass, i3.NgForOf, i3.NgIf, i4.IconDirective, i5.LoadingSymbolComponent], encapsulation: 2 });
